import React, { Component } from "react";
import { HiPlus } from "react-icons/hi";
import { Link } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";
import Empty from "../../../base/features/blocks/Empty";
import SimpleHeader from "../../../base/features/blocks/SimpleHeader";
import Spinner from "../../../base/features/micro/Spinner";
import { shopTerms, shopTermsMore } from "./services";

class ShopTerms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopUid: window.location.pathname.split("/")[2],
      terms: null,
      moreTerms: null,
      termsMoreModal: false,
    };
  }
  componentDidMount() {
    this.get_terms();
  }
  get_terms() {
    shopTerms(this.state.shopUid).then((items) => {
      items && this.setState({ terms: items.results });
    });
  }
  get_more_terms() {
    shopTermsMore().then((items) => {
      items && this.setState({ moreTerms: items });
    });
  }

  render() {
    return (
      <div className="container-fluid px-0">
        <SimpleHeader
          text={"توضیحات تکمیلی و قوانین"}
          path={`/dashboard/${this.state.shopUid}`}
        />
        <body style={{ marginTop: "62px" }}>
          <div className="row mx-0">
            <div className="col-12 px-4 py-3">
              <div className="bg-light-gray rounded14 p-3 fs-7 fw-bold">
                جهت شفاف سازی رویه فروشگاه تان برای خریداران، بهتر است مدت زمان
                معمول آماده سازی سفارش ها، چگونگی ارسال و هزینه آن، قوانین فروش،
                برگشت و لغو سفارشات را ثبت نمائید.
                <span
                  className="color-main"
                  onClick={() => {
                    this.setState({ termsMoreModal: true });
                    this.get_more_terms();
                  }}
                >
                  توضیحات بیشتر
                </span>
              </div>
            </div>
          </div>
          {this.state.terms ? (
            this.state.terms.length === 0 ? (
              <Empty text={"توضیحات تکمیلی ثبت نشده"} />
            ) : (
              this.state.terms.map((term, t) => (
                <div className="row mx-0 px-4 py-3 border-bottom">
                  <div className="col-12 px-0 fw-bold">
                    <h3 className="fs-5">{term.title}</h3>
                    <p className="text-muted fs-7">{term.des}</p>
                    <Link
                      to={{
                        pathname: `/dashboard/${this.state.shopUid}/term-detail/${term.uid}`,
                        state: {
                          terms: this.state && this.state.terms,
                        },
                      }}
                    >
                      <p className="mb-0 text-start color-main">ویرایش</p>
                    </Link>
                  </div>
                </div>
              ))
            )
          ) : (
            <Spinner />
          )}
          <div
            dir="ltr"
            className="position-fixed"
            style={{ bottom: "20px", left: "20px" }}
          >
            <Link
              to={{
                pathname: `/dashboard/${this.state.shopUid}/term-detail`,
                state: {
                  terms: this.state.terms && this.state.terms,
                },
              }}
            >
              <div
                className="rounded-circle row mx-0 nav-bottom-grad"
                style={{
                  height: "65px",
                  width: "65px",
                }}
              >
                <div className="col align-self-center text-center px-0">
                  <HiPlus size="38" className="text-white" />
                </div>
              </div>
            </Link>
          </div>
        </body>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.state.termsMoreModal}
          toggle={() => this.setState({ termsMoreModal: false })}
        >
          <ModalBody className="row mx-0 p-4">
            {this.state.moreTerms ? (
              <div className="col-12 px-0 py-2">
                {this.state.moreTerms.length === 0 ? (
                  <Empty text={"موردی یافت نشد"} />
                ) : (
                  this.state.moreTerms.map((term, t) => (
                    <div>
                      <h2 className="fw-bold fs-4">{term.title}</h2>
                      <p
                        className="fw-bold text-muted"
                        style={{
                          whiteSpace: "pre-wrap",
                          lineHeight: "1.7em",
                        }}
                      >
                        {term.des}
                      </p>
                    </div>
                  ))
                )}
              </div>
            ) : (
              <Spinner />
            )}
            <button
              onClick={() => this.setState({ termsMoreModal: false })}
              className="btn rounded28 py-2 w-100 fw-bold bg-color-main text-center text-white"
            >
              متوجه شدم
            </button>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default ShopTerms;
